module.exports = __webpack_public_path__ + "media/img/frontend_application/venue/fb-icon-90c6cbc3cdf2b80d04fe732e115d245a.png";